import { GamtestResult } from "../generated-api-proxy";
import { GroupScoreViewModel } from "./group-score-view-model";

export class GamtestViewModel {
  created_at!: Date;
  updated_at!: Date;
  missing: boolean = true;
  outdated: boolean = false;
  total: GroupScoreViewModel = GroupScoreViewModel.empty();
  dimentions: GroupScoreViewModel[] = [];

  constructor(gamtest: GamtestResult) {
    if (gamtest["created_at"])
      this.created_at = new Date(gamtest["created_at"]);
    if (gamtest["updated_at"])
      this.created_at = new Date(gamtest["updated_at"]);
    if (gamtest["total"]) {
      this.total = new GroupScoreViewModel(gamtest["total"], "total");
      this.missing = gamtest["total"]["missing"] === true;
    }

    if (this.missing) return;

    for (var i in gamtest) {
      if (i == 'created_at') continue;
      if (i == 'updated_at') continue;
      if (i == 'outdated') continue;
      if (i == 'total') continue;

      this.dimentions.push(new GroupScoreViewModel(gamtest[i], i));
    }
  }

  static empty(): GamtestViewModel {
    return new GamtestViewModel(new GamtestResult());
  }
}
